import { render, staticRenderFns } from "./DocumentTypeGrid.vue?vue&type=template&id=6c94b7c4&scoped=true"
import script from "./DocumentTypeGrid.vue?vue&type=script&lang=js"
export * from "./DocumentTypeGrid.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeGrid.vue?vue&type=style&index=0&id=6c94b7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94b7c4",
  null
  
)

export default component.exports